import { ArrowUpRight } from "lucide-react";

import { SectionHeading } from "@/components/site/Blocks";
import { JYNTIX_PRODUCTS, JYNTIX_URL } from "@/lib/jyntix";

export function JyntixPortfolio({ locale = "en" }: { locale?: "en" | "tr" }) {
  const tr = locale === "tr";

  return (
    <section id="jyntix" className="scroll-mt-24 bg-secondary">
      <div className="section-shell py-20">
        <SectionHeading
          eyebrow={tr ? "OXORY markası" : "An OXORY brand"}
          title="JYNTIX"
          lead={
            tr
              ? "Kurumsal entegrasyon, yapay zekâ destekli geliştirme, SAP IDoc izleme ve dijital yönetişim için dört ürün."
              : "Four enterprise products for integration, AI-assisted development, SAP IDoc monitoring and digital governance."
          }
        />
        <a
          href={JYNTIX_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-primary hover:underline"
          aria-label={tr ? "JYNTIX web sitesini açın (yeni sekmede açılır)" : "Visit JYNTIX (opens in a new tab)"}
        >
          {tr ? "JYNTIX web sitesini ziyaret edin" : "Visit JYNTIX"}
          <ArrowUpRight className="size-4" aria-hidden="true" />
        </a>

        <ul className="mt-10 grid gap-6 md:grid-cols-2">
          {JYNTIX_PRODUCTS.map((product) => (
            <li key={product.name}>
              <a
                href={product.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex h-full flex-col rounded-lg border border-border bg-card p-6 shadow-card transition-colors hover:border-primary"
                aria-label={`${product.name} — JYNTIX (${tr ? "yeni sekmede açılır" : "opens in a new tab"})`}
              >
                <p className="eyebrow text-primary">JYNTIX</p>
                <h3 className="mt-2 font-display text-lg font-bold group-hover:text-primary">
                  {product.name}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">
                  {tr ? product.descriptionTr : product.descriptionEn}
                </p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary">
                  {tr ? "Ürün sayfasını açın" : "Open product page"}
                  <ArrowUpRight className="size-4" aria-hidden="true" />
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}